/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".columnSettings[_ngcontent-%COMP%]{padding-left:.5rem;list-style:none}.columnSettings[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-right:.5rem;box-sizing:border-box;width:35px;height:35px;padding:4px 0 0}.dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.filter-alert[_ngcontent-%COMP%]{cursor:pointer}"];
export { styles as styles };
